import { useState, useEffect } from "react";
import { setupModemByRegNumber } from "../../api/inventory";
import AlertBox from "../../components/AlertBox";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import BoxNasList from "../../components/radius/BoxNasList";
import { useModemByRegistrationHooks, useModemBySerialHooks } from "../../utils/InventoryHooks";
import { useALlFramedPool } from "../../utils/radius/FramedPoolUtil";
import { useAuth } from "../../utils/AuthHooks";
import BoxUnsavedModem from "../../components/inventory/modem/BoxUnsavedModem";
import BoxSetupModem from "../../components/inventory/modem/BoxSetupModem";
import BoxDismantleModem from "../../components/inventory/modem/BoxDismantleModem";
import BoxRelocateModem from "../../components/inventory/modem/BoxRelocateModem";
import Toggle from "react-toggle";
import IconvestFormSetupModem from "../../components/inventory/IconvestFormSetupModem";
import OdpPicker from "../../components/infrastrucure/odp/OdpPicker";

import { useRegistrationNetworkConfigPreviewHooks } from "../../utils/SetupModemUtils";
import ModalNetworkConfigPreview from "../../components/inventory/modem/ModalNetworkConfigPreview";

export default function SetupModemPage() {
  const auth = useAuth();
  const modem = useModemBySerialHooks();
  const registrationData = useModemByRegistrationHooks();
  const [loading, setLoading] = useState(false);
  const framedPools = useALlFramedPool({});
  const preview = useRegistrationNetworkConfigPreviewHooks();
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [regisNumber, setRegisNumber] = useState("");
  const [inputSerial, setInputSerial] = useState("");
  const [override, setOverride] = useState(false);
  const [modemInfo, setModemInfo] = useState({ serial_number_gpon: "" });
  const [odpInput, setOdpInput] = useState("");
  // list olts from projects
  const [oltList, setOltList] = useState([]);

  const [form, setForm] = useState({
    pppoe_username: "",
    pppoe_password: "",
    framed_pool: "",
    new_framed_pool: "",
    olt: "",
    olt_id: "",
    inventory_modem_id: "",
    vlan: "",
    odp: "",
    odc: "",
    odp_port: "",
    ont_damping: "",
    odp_damping: "",
    skip_old_modem_termination: "false",

    odp_select: null,
  });

  useEffect(() => {
    const loadDataForm = () => {
      setInputSerial(registrationData.data.inventory_modem_pair.modem?.serial_number_modem || "");

      if (registrationData.data.project?.partner?.code !== "ICONNET") {
        setForm({
          pppoe_username: registrationData.data.inventory_modem_pair.modem?.pppoe_username || "",
          pppoe_password: registrationData.data.inventory_modem_pair.modem?.pppoe_password || "",
          framed_pool: registrationData.data.inventory_modem_pair.modem?.framed_pool || "",
          olt_id: registrationData.data.network_config?.olt_id || "",
          olt: registrationData.data.inventory_modem_pair.modem?.olt || "",
          vlan: registrationData.data.inventory_modem_pair.modem?.vlan || "",
          odp: registrationData.data.inventory_modem_pair.modem?.odp || "",
          odc: registrationData.data.inventory_modem_pair.modem?.odc || "",
          odp_port: registrationData.data.inventory_modem_pair.modem?.odp_port || "",
          ont_damping: registrationData.data.inventory_modem_pair.modem?.ont_damping || "",
          odp_damping: registrationData.data.inventory_modem_pair.modem?.odp_damping || "",
          inventory_modem_id: registrationData.data.inventory_modem_pair.modem?.id,
          skip_old_modem_termination: "false",

          odp_select:
            registrationData.data.network_config?.odp == null
              ? null
              : registrationData.data.network_config?.odp,
        });

        setOdpInput(registrationData.data.network_config?.odp == null ? "manual" : "list");
      }

      setModemInfo({ ...registrationData.data.inventory_modem_pair.modem });
      if (registrationData.data.inventory_modem_pair.modem.automation === 1) {
        setOverride(false);
      } else {
        setOverride(true);
      }
    };

    if (registrationData.fetched) {
      if (registrationData.data.inventory_modem_pair !== null) {
        loadDataForm();
      } else {
        setForm({
          pppoe_username: "",
          pppoe_password: "",
          framed_pool: "",
          olt: "",
          olt_id: "",
          vlan: "",
          odp: "",
          odc: "",
          inventory_modem_id: "",
          odp_port: "",
          ont_damping: "",
          odp_damping: "",
          skip_old_modem_termination: "false",

          odp_select: null,
        });
        setInputSerial("");
        setModemInfo({ serial_number_gpon: "", automation: 1 });
      }

      let tempOlts = [];
      if (registrationData.data.project?.olts?.length > 0) {
        tempOlts = [...registrationData.data.project.olts];
      }

      setOltList(tempOlts);
      modem.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registrationData.fetched]);

  useEffect(() => {
    if (modem.fetched) {
      setForm({ ...form, inventory_modem_id: modem.data.id });
      setModemInfo({ ...modem.data });
      if (modem.data.automation === 1) {
        setOverride(false);
      } else {
        setOverride(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modem.fetched]);

  useEffect(() => {
    if (preview.error) {
      setAlert({ show: true, message: preview.error, type: "danger" });
    }
  }, [preview.error]);

  useEffect(() => {
    if (preview.fetched && preview.data) {
      setShowPreviewModal(true);
    }
  }, [preview.fetched, preview.data]);

  const checkSerial = (event) => {
    event.preventDefault();
    if (inputSerial) {
      modem.getModem(inputSerial);
    }
  };

  const loadRegistration = (event) => {
    event.preventDefault();
    if (regisNumber) {
      registrationData.getRegistration(regisNumber);
    }
  };

  const resetForm = () => {
    setRegisNumber("");
    registrationData.reset();
    modem.reset();
    setInputSerial("");
    setOverride(false);
    setOdpInput("");
    setModemInfo({ serial_number_gpon: "" });
    setForm({
      pppoe_username: "",
      pppoe_password: "",
      framed_pool: "",
      new_framed_pool: "",
      inventory_modem_id: "",
      olt: "",
      olt_id: "",
      vlan: "",
      odp: "",
      odc: "",
      odp_port: "",
      ont_damping: "",
      odp_damping: "",
      skip_old_modem_termination: "",

      odp_select: null,
    });
  };

  const setupModem = async (form_data) => {
    setLoading(true);
    try {
      let { data } = await setupModemByRegNumber(registrationData.data.id, form_data);
      setAlert({ show: true, message: data.message, type: "success" });
      resetForm();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }
      setAlert({ show: true, message: message, type: "danger" });
    }

    window.scrollTo(0, 0);
    setLoading(false);
  };

  const submitData = (event) => {
    event.preventDefault();
    let formData = {
      pppoe_username: form.pppoe_username,
      pppoe_password: form.pppoe_password,
      framed_pool: form.framed_pool,
      olt: form.olt,
      olt_id: form.olt_id,
      vlan: form.vlan,
      odp: form.odp,
      odc: form.odc,
      inventory_modem_id: form.inventory_modem_id,
      override_automation: String(override),
      odp_port: form.odp_port,
      ont_damping: form.ont_damping.toString(),
      odp_damping: form.odp_damping.toString(),
      skip_old_modem_termination: form.skip_old_modem_termination,

      // TODO: add odp_id to send data
      odp_id: form.odp_select?.id,
    };

    if (formData.framed_pool === "add_new") {
      formData.framed_pool = "";
      formData.new_framed_pool = form.new_framed_pool;
    }

    setupModem(formData);
  };

  const submitDataIconvest = (iconnetForm) => {
    let formData = {
      ...iconnetForm,
    };

    setupModem(formData);
  };

  const disabledByRole = (roles = [], allowed = []) => {
    return roles.some((role) => allowed.includes(role.name));
  };

  const canEditForm = () => {
    if (modemInfo.automation === 1) {
      // jika modem bisa di-otomasi
      // maka return override value
      // jika override true, maka form dapat diedit
      return override;
    }

    return true;
  };

  return (
    <MainLayout>
      <div className="container-fluid">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Setup Modem</h1>
        </div>
        <div className="row">
          <div className="col-12 col-lg-4">
            <Box title="Form Setup Modem">
              <form onSubmit={(event) => loadRegistration(event)}>
                <div className="form-group">
                  <label>Nomor Registrasi:</label>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        value={regisNumber}
                        onChange={(event) => setRegisNumber(event.target.value)}
                        className="form-control"
                        placeholder="Masukan nomor registrasi"
                      />
                      {registrationData.loading && (
                        <span className="text-dark">Mengecek registrasi...</span>
                      )}
                      {registrationData.fetched && (
                        <span className="text-success">Berhasil memuat data registrasi</span>
                      )}
                      {registrationData.error && (
                        <span className="text-danger">{registrationData.error}</span>
                      )}
                    </div>
                    <div className="col-auto">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={registrationData.loading}
                      >
                        Input Nomor
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <div className="row">
                <div className="col-12 pt-3 pb-2">
                  <h4>Informasi Pelanggan</h4>
                </div>
                <div className="col-12">
                  <AlertBox {...alert} setAlert={setAlert} />
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td>Nomor Registrasi</td>
                        <td>{registrationData.data.registration_number || "-"}</td>
                      </tr>
                      <tr>
                        <td>Nama</td>
                        <td>{registrationData.data.name || "-"}</td>
                      </tr>
                      <tr>
                        <td>Paket</td>
                        <td>
                          {registrationData.data.internet_package?.name || "-"}{" "}
                          {registrationData.data.internet_package &&
                            `(${registrationData.data.internet_package.internet_package_varian.amount} ${registrationData.data.internet_package.internet_package_varian.unit})`}
                        </td>
                      </tr>
                      <tr>
                        <td>Status Pendaftaran</td>
                        <td>{registrationData.data.status?.display_name || "-"}</td>
                      </tr>
                      <tr>
                        <td>Status Billing</td>
                        <td>{registrationData.data.billing_status || "-"}</td>
                      </tr>
                      <tr>
                        <td>Catatan</td>
                        <td>{registrationData.data.note || "-"}</td>
                      </tr>
                      <tr>
                        <td>Alamat Pemasangan</td>
                        <td>
                          {registrationData.data.installation_address ? (
                            <>
                              {registrationData.data.installation_address?.address} RT{" "}
                              {registrationData.data.installation_address?.rt} RW{" "}
                              {registrationData.data.installation_address?.rw},
                              {registrationData.data.installation_address?.addresses.kelurahan},{" "}
                              {registrationData.data.installation_address?.addresses.kecamatan},{" "}
                              {registrationData.data.installation_address?.addresses.kota_kab},{" "}
                              {registrationData.data.installation_address?.addresses.province},{" "}
                              {registrationData.data.installation_address?.addresses.postal_code}
                            </>
                          ) : (
                            <>-</>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="pt-3 pb-2">
                    <h4>Informasi Perangkat</h4>
                  </div>
                  {registrationData.data.project?.partner?.code !== "ICONNET" ? (
                    <>
                      <form onSubmit={(event) => submitData(event)}>
                        <div className="form-group">
                          <label>Nomor Serial Modem:</label>
                          <div className="row">
                            <div className="col">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Serial Modem"
                                value={inputSerial}
                                onChange={(event) => setInputSerial(event.target.value)}
                              />
                              {modem.loading && (
                                <span className="text-dark">Mengecek modem...</span>
                              )}
                              {modem.fetched && (
                                <span className="text-success">Modem tersedia</span>
                              )}
                              {modem.error && (
                                <span className="text-danger">
                                  Modem tidak tersedia ({modem.error})
                                </span>
                              )}
                            </div>
                            <div className="col-auto">
                              <button
                                className="btn btn-primary"
                                type="button"
                                disabled={modem.loading}
                                onClick={(event) => checkSerial(event)}
                              >
                                Cek Modem
                              </button>
                            </div>
                          </div>
                        </div>
                        {modemInfo.automation === 0 && (
                          <div className="alert alert-warning">
                            <b>
                              <i className="fa-solid fa-triangle-exclamation"></i> Perhatian
                            </b>{" "}
                            <br />
                            Modem ini tidak dapat disetup otomatis. Hubungi NOC untuk melakukan
                            setup manual.
                          </div>
                        )}

                        <div className="form-group">
                          <label>Nomor GPON</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={true}
                            value={modemInfo.serial_number_gpon}
                          />
                        </div>
                        <div className="form-group row">
                          <div className="col-auto">
                            <label>Setup modem manual</label>
                          </div>
                          <div className="col-auto">
                            <Toggle
                              checked={override}
                              onChange={(event) => {
                                setOverride(event.target.checked);
                              }}
                              disabled={
                                disabledByRole(auth.user.roles, ["technician"]) ||
                                modemInfo.automation !== 1
                              }
                            />
                          </div>
                        </div>
                        {registrationData.data.inventory_modem_pair !== null ? (
                          <div className="form-group row">
                            <div className="col-auto">
                              <label>Manual Terminate</label>
                            </div>
                            <div className="col-auto">
                              <Toggle
                                checked={form.skip_old_modem_termination === "true"}
                                onChange={(event) => {
                                  let value = "false";
                                  if (event.target.checked) {
                                    value = "true";
                                  }

                                  setForm({ ...form, skip_old_modem_termination: value });
                                }}
                              />
                            </div>
                          </div>
                        ) : null}
                        <div className="form-group">
                          <label>PPPoE Username</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={
                              disabledByRole(auth.user.roles, ["technician"]) || !canEditForm()
                            }
                            value={form.pppoe_username}
                            onChange={(event) =>
                              setForm({ ...form, pppoe_username: event.target.value })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label>PPPoE Password</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={
                              disabledByRole(auth.user.roles, ["technician"]) || !canEditForm()
                            }
                            value={form.pppoe_password}
                            onChange={(event) =>
                              setForm({ ...form, pppoe_password: event.target.value })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label>OLT</label>
                          <div className="row">
                            <div className="col">
                              <select
                                className="form-control"
                                value={form.olt_id}
                                disabled={odpInput !== "manual"}
                                onChange={(event) =>
                                  setForm({ ...form, olt_id: event.target.value })
                                }
                              >
                                <option value="">-- Pilih OLT --</option>
                                {oltList.map((olt) => (
                                  <option key={olt.id} value={olt.id}>
                                    {olt.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-auto">
                              <button
                                type="button"
                                className="btn btn-primary"
                                disabled={preview.loading || !form.olt_id}
                                onClick={() =>
                                  preview.fetchNetworkConfigPreview({
                                    registration_id: registrationData.data.id,
                                    olt_id: form.olt_id,
                                  })
                                }
                              >
                                {preview.loading ? "Memuat..." : "Preview Config"}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>OLT Port</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={
                              disabledByRole(auth.user.roles, ["technician"]) || !canEditForm()
                            }
                            value={form.olt}
                            onChange={(event) => setForm({ ...form, olt: event.target.value })}
                          />
                        </div>
                        <div className="form-group">
                          <label>Framed Pool</label>
                          <select
                            className="form-control"
                            value={form.framed_pool}
                            disabled={
                              disabledByRole(auth.user.roles, ["technician"]) || !canEditForm()
                            }
                            onChange={(event) =>
                              setForm({ ...form, framed_pool: event.target.value })
                            }
                          >
                            <option value=""></option>
                            {framedPools.data.map((framed_pool, index) => (
                              <option key={index} value={framed_pool.name}>
                                {framed_pool.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group">
                          <label>VLAN</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={
                              disabledByRole(auth.user.roles, ["technician"]) || !canEditForm()
                            }
                            value={form.vlan}
                            onChange={(event) => setForm({ ...form, vlan: event.target.value })}
                          />
                        </div>

                        <div className="form-group">
                          <label>ODC</label>
                          <input
                            type="text"
                            className="form-control"
                            value={form.odc}
                            onChange={(event) => setForm({ ...form, odc: event.target.value })}
                          />
                        </div>
                        <div className="form-group">
                          <label>ODP</label>
                          <div className="row mb-2">
                            <label className="col-6 mb-0">
                              <input
                                type="radio"
                                name="odp-input"
                                value="list"
                                checked={odpInput === "list"}
                                onChange={(event) => {
                                  setOdpInput(event.target.value);
                                  setForm({ ...form, odp: "", odp_select: null });
                                }}
                              />{" "}
                              List
                            </label>
                            <label className="col-6 mb-0">
                              <input
                                type="radio"
                                name="odp-input"
                                value="manual"
                                checked={odpInput === "manual"}
                                onChange={(event) => {
                                  setOdpInput(event.target.value);
                                  setForm({ ...form, odp: "", odp_select: null });
                                }}
                              />{" "}
                              Manual
                            </label>
                          </div>
                          {odpInput === "manual" ? (
                            <input
                              type="text"
                              className="form-control"
                              value={form.odp}
                              onChange={(event) => setForm({ ...form, odp: event.target.value })}
                              placeholder="Masukkan ODP secara manual"
                            />
                          ) : (
                            <OdpPicker
                              value={form.odp_select}
                              onManual={(odp_string) => {
                                setOdpInput("manual");
                                setForm({ ...form, odp: odp_string });
                              }}
                              onChange={(odp) => {
                                setForm({
                                  ...form,
                                  odp_select: odp,
                                  olt_id: odp?.olt.id,
                                });
                              }}
                            />
                          )}
                        </div>
                        <div className="form-group">
                          <label>Port ODP</label>
                          <input
                            type="text"
                            className="form-control"
                            value={form.odp_port}
                            onChange={(event) => setForm({ ...form, odp_port: event.target.value })}
                          />
                        </div>
                        <div className="form-group">
                          <label>Redaman ODP</label>
                          <input
                            type="number"
                            className="form-control"
                            value={form.odp_damping}
                            onChange={(event) =>
                              setForm({ ...form, odp_damping: event.target.value })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label>Redaman ONT</label>
                          <input
                            type="number"
                            className="form-control"
                            value={form.ont_damping}
                            onChange={(event) =>
                              setForm({ ...form, ont_damping: event.target.value })
                            }
                          />
                        </div>
                        <div className="col-12 d-flex justify-content-end">
                          <button className="btn btn-primary" disabled={loading}>
                            {loading ? "Mensetup modem ..." : "Simpan Setting Modem"}
                          </button>
                        </div>
                      </form>
                    </>
                  ) : (
                    <IconvestFormSetupModem
                      registration={registrationData.data}
                      onSubmit={submitDataIconvest}
                      submitLoading={loading}
                    />
                  )}
                </div>
              </div>
            </Box>
          </div>

          <div className="col-lg-8">
            <BoxSetupModem />
            <BoxUnsavedModem />
            <BoxDismantleModem />
            <BoxRelocateModem />
            <BoxNasList />
          </div>
          <ModalNetworkConfigPreview
            show={showPreviewModal}
            data={preview.data}
            onClose={() => setShowPreviewModal(false)}
          />
        </div>
      </div>
    </MainLayout>
  );
}
